import * as React from "react";

import AppPage from "@/ui/AppPage/AppPage";
import SigurnosnePorukeTable from "./SigurnosnePorukeTable";

import Box from '@mui/material/Box';

import { Permissions } from "@/lib/permissions";

function SigurnosnePorukePage() {
  return (
    <AppPage needPermission={[Permissions.Administration]}>
      <Box m={0} style={{ height: "100%" }}>
        <SigurnosnePorukeTable />
      </Box>
    </AppPage>
  );
}

export default SigurnosnePorukePage;
